import React from 'react';

export const Copyright = () => {
  return (
    <div className="text-xs text-center text-gray-500 dark:text-gray-400 px-2">
      <p>
        &copy; {new Date().getFullYear()}
        <a className="mx-1" href="https://www.vitazi.ai/">
          Vitazi.ai
        </a>
        Inc. All Rights reserved. |
        <a className="mx-1" href="https://www.vitazi.ai/terms-of-use">
          Terms of Use
        </a>
        {'|'}
        <a className="mx-1" href="https://www.vitazi.ai/privacy-policy">
          Privacy Policy
        </a>
      </p>
    </div>
  );
};
